<template>
  <div>
    <div ref="chart" :style="getStyles()" :id="`fw-chart-${id}`"></div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'FwChart',
  props: {
    legend: { // 控制图例的Symbol
      type: Object,
      default () {
        return {}
      }
    },
    value: { // 传入echarts的dataset对象
      type: Object,
      default () {
        return {
          dimensions: [],
          source: []
        }
      }
    },
    width: {
      type: String,
      default: '600px'
    },
    height: {
      type: String,
      default: '400px'
    },
    type: { // 图例类型, line: 折线图, bar: '柱形图', etc.
      type: String,
      default: 'line'
    },
    colors: { // 每个Symbol的颜色
      type: Array,
      default () {
        return []
      }
    },
    extend: { // 传入echarts的option配置, doc: http://echarts.baidu.com/option.html
      type: Object,
      default () {
        return {}
      }
    },
    id: {
      type: String
    },
    xRotate: { // x轴标签旋转，不旋转标签多的时候显示不了最后一个
      type: Number,
      default: 45
    }
  },
  components: {
    echarts
  },
  data () {
    return {
      chart: {},
      option: {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            rotate: this.xRotate
          }
        },
        yAxis: {},
        legend: this.legend,
        dataset: {
          dimensions: [],
          source: []
        },
        series: []
      }
    }
  },
  watch: {
    value (val) {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    getStyles () {
      return {
        width: this.width,
        height: this.height
      }
    },
    init () {
      if (!this.value.dimensions || !this.value.source) {
        return
      }
      if (this.value.dimensions.length <= 0 || this.value.source.length <= 0) {
        return
      }
      this.handleSeries()
      this.option.dataset = this.value
      const el = this.id ? document.getElementById(`fw-chart-${this.id}`) : this.$refs['chart']
      this.chart = echarts.init(el)
      this.chart.setOption(Object.assign({}, this.option, this.extend), true)
      this.chart.resize()
    },
    handleSeries () {
      const dimensions = this.value.dimensions.slice(1) // remove the first item
      this.option.series = dimensions.map((item, i) => {
        return {
          type: this.type,
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          itemStyle: {
            normal: {
              color: this.colors[i]
            }
          }
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Common/FwChart.vue